export default "__VITE_ASSET__D$A4nne1__"